var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('textarea',{staticStyle:{"padding":"20px","width":"100%"},domProps:{"innerHTML":_vm._s(_vm.params.data)}})])}
var staticRenderFns = []

export { render, staticRenderFns }